export default "__VITE_ASSET__CZcHcilB__"